<template>
  <div class="WorkReportTop-Com">
    <div class="LeftTitle-Com">
      工作报告
    </div>
    <div class="rightTitle-Com">
      *报告可不定期更新，但请每周保持跟进
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.WorkReportTop-Com {
  width: 100%;
  border-bottom: 1px solid #ebedf0;
  padding-top: 8px;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;

  .LeftTitle-Com {
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #16181a;
  }
  .rightTitle-Com {
    width: 246px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #e71d43;
  }
}
</style>